interface IProps {
    onClick?: () => void;
    color?: string;
}

export const HomeIcon = (props: IProps) => {
    const { onClick, color } = props;

    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                onClick={onClick}
            >
                <g id="Group_3403" data-name="Group 3403" transform="translate(-15 -111)">
                    <circle
                        id="Ellipse_128"
                        data-name="Ellipse 128"
                        cx="13"
                        cy="13"
                        r="13"
                        transform="translate(15 111)"
                        opacity="0.39"
                        fill={color || "#eee"}
                    />
                    <g id="house" transform="translate(23.368 117.343)">
                        <path
                            id="Path_11909"
                            data-name="Path 11909"
                            d="M13.739,5.988,9.072,2.057a.246.246,0,0,0-.317,0L4.087,5.988A.246.246,0,0,0,4,6.176v6.142a.491.491,0,0,0,.491.491H7.439V9.615a.246.246,0,0,1,.246-.246h2.457a.246.246,0,0,1,.246.246v3.194h2.948a.491.491,0,0,0,.491-.491V6.176A.246.246,0,0,0,13.739,5.988Z"
                            transform="translate(-4 -1.999)"
                            fill="#fff"
                        />
                    </g>
                </g>
            </svg>
        </>
    );
};
